<template>
    <div class="dropdown dd-container" v-click-outside="vcoConfig">
        <div class="dd-button" @click="open = !open" :class="{ open: open }">
            Options
        </div>
        <ul class="dd-menu" :class="{ open: open }">
            <slot></slot>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            open: false,
        };
    },
    computed: {
        vcoConfig() {
            return {
                handler: this.closeDropdown,
                isActive: this.open,
                capture: true,
            };
        },
    },
    methods: {
        closeDropdown() {
            if (this.open) this.open = false;
        },
    },
};
</script>

<style lang="scss">
@import "../../style/common/DropdownButton.scss";
</style>
